import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";

import { useEstateContext } from "@/context/EstateContext";
import { useLanguage } from "@/context/LanguageContext";
import { RoundButtonWithToggleIcon } from "@/components/tools/RoundButtonWithToggleIcon";
import { Calendar1, CalendarCheck } from "lucide-react";

export function AllPortfolioActionButtons({
  showTitle = true,
}: {
  showTitle?: boolean;
}) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      summary: "Souhrn portfolia",
      showCurrent: "Zobrazit aktuální",
      showPrediction: "Zobrazit predikci",
    },
    en: {
      summary: "Portfolio summary",
      showCurrent: "Show current",
      showPrediction: "Show forecast",
    },
  }[language];

  const { isPredictionView, setIsPredictionView } = useEstateContext();

  const actions = (
    <RoundButtonsContainer>
      <RoundButtonWithToggleIcon
        icon={isPredictionView ? CalendarCheck : Calendar1}
        isActive={isPredictionView}
        onClick={() => setIsPredictionView((prev) => !prev)}
        tooltipTextActive={copy.showCurrent}
        tooltipTextInactive={copy.showPrediction}
        activeClassName="text-softiq-secondary"
      />
    </RoundButtonsContainer>
  );

  if (!showTitle) return actions;

  return (
    <div className="flex items-center justify-between gap-4">
      <PortfolioPageSectionBadge type={"dark"}>
        {copy.summary}
      </PortfolioPageSectionBadge>
      {actions}
    </div>
  );
}
